module.exports = __webpack_public_path__ + "static/pcr-home-cf97ec65af1050fd7e54b9c746e25694.svg";